'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dUser$002dStats from "./presto.types$-Dashboard-User-Stats.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DashboardUserStats$() {
}
export { $c_Lpresto_types$DashboardUserStats$ as $c_Lpresto_types$DashboardUserStats$ };
$p = $c_Lpresto_types$DashboardUserStats$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DashboardUserStats$;
/** @constructor */
function $h_Lpresto_types$DashboardUserStats$() {
}
export { $h_Lpresto_types$DashboardUserStats$ as $h_Lpresto_types$DashboardUserStats$ };
$h_Lpresto_types$DashboardUserStats$.prototype = $p;
$p.l = (function() {
  return "DashboardUserStats";
});
$p.cFV = (function(x$0) {
  return new $j_presto$002etypes$0024$002dDashboard$002dUser$002dStats.$c_Lpresto_types$DashboardUserStats($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(x$0.j(0)), x$0.j(1), (x$0.j(2) | 0));
});
var $d_Lpresto_types$DashboardUserStats$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DashboardUserStats$, "presto.types$DashboardUserStats$", ({
  ZL: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$DashboardUserStats$ as $d_Lpresto_types$DashboardUserStats$ };
var $n_Lpresto_types$DashboardUserStats$;
function $m_Lpresto_types$DashboardUserStats$() {
  if ((!$n_Lpresto_types$DashboardUserStats$)) {
    $n_Lpresto_types$DashboardUserStats$ = new $c_Lpresto_types$DashboardUserStats$();
  }
  return $n_Lpresto_types$DashboardUserStats$;
}
export { $m_Lpresto_types$DashboardUserStats$ as $m_Lpresto_types$DashboardUserStats$ };
//# sourceMappingURL=presto.types$-Dashboard-User-Stats$.js.map
